import { createSelector } from '@ngrx/store';

import * as fromReducer from '@packages/packages-result/store/reducers/flight-results.reducer';
import { PackageResultModuleState } from '@packages/packages-result/store/state/packages-result-module.state';
import { packagesResultRootSelector } from '@packages/packages-result/store/selectors/packages-result-root.selector';

export const getFlightlResultsState = createSelector(
  packagesResultRootSelector, (state: PackageResultModuleState) => state?.flightResults || {});

export const selectAllFlightResults = createSelector(getFlightlResultsState, fromReducer.selectAll);
export const selectFlightResultsEntities = createSelector(getFlightlResultsState, fromReducer.selectEntities);

export const selectFlightResultById = (id: number) => createSelector(selectFlightResultsEntities, entities => entities[id]);
